import React from 'react';
import { Button } from '@lb-service/ui';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import appUtils from '../../../../utils/appUtils';

const CoursesIndexHero = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { locale } = router;
  return (
    <div className="hero font-white">
      <div className="hero-background background-courses-index" />
      <div className="courses-hero-content max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="va-container va-container-v va-container-h">
          <div className="va-middle">
            <div className="text-center col-center lg:col-span-8">
              <h1 className="text-3xl text-white mb-4">
                {t('service.courses.index.hero.title')}
              </h1>
              <h2 className="text-xl text-white mb-8">
                <span>{t('service.courses.index.hero.intro')}</span>
                <br />
              </h2>
              <a href={appUtils.getAppPath(locale, 'signup')}>
                <Button size="lg" type="button">
                  <span className="text-center">{t('links.signup')}</span>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default CoursesIndexHero;
